import React from "react";
import { useLang } from "../context/LangContext";
import { Languages } from "lucide-react";

export default function LanguageSwitcher() {
  const { toggle, t } = useLang();
  return (
    <button
      data-testid="language-switcher-btn"
      onClick={toggle}
      className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-[#E5E1D8] bg-white/70 text-sm hover:bg-white transition-colors"
    >
      <Languages size={16} />
      <span>{t("language")}</span>
    </button>
  );
}
